import { NormalizedUnitNumber, Percentage } from '@/domain/types/NumericValues'

export function calculateLiquidationPrice(
  currentPrice: NormalizedUnitNumber,
  currentLtv: Percentage,
  maxLtv: Percentage,
): NormalizedUnitNumber {
  if (currentLtv.isZero() || maxLtv.isZero()) {
    return NormalizedUnitNumber(0)
  }

  return NormalizedUnitNumber(currentPrice.multipliedBy(currentLtv.dividedBy(maxLtv)))
}
